import {
    put, takeLatest, call
} from 'redux-saga/effects';
import {
    GET_DASHBOARD, getDashboard,
    GET_MERCHANT_DETAILS, getMerchantDetails,
    GET_MERCHANT_LOCATIONS, getMerchantLocations,
    GET_MERCHANT_REPORT, getMerchantReport,
    GET_ACCOUNT_DATA, getAccountData,
    GET_ACCOUNT_USERS, getAccountUsers,
    GET_USER_ACCOUNT, getUserAccount,
    ADD_USER_ACCOUNT, addUserAccount,
    UPDATE_USER_ACCOUNT, updateUserAccount,
    UPDATE_ACCOUNT_DATA, updateAccountData,
    GET_TOTAL_LOCATIONS_COUNT, getTotalLocationsCount
} from '../actions';
import { Api } from '../components/Authenticate/Authenticate';
import { getActiveConceptId, setActiveConceptId } from '../utilities';


function* handleGetDashboard({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const params = {
        sales_summary_date_start: payload ? payload.reportDateRange : null,
        sales_summary_date_end: payload ? payload.sales_summary_date_end : null,
        merchant_id: getActiveConceptId({ redirect: false })
    };

    try {
        const response = yield call(Api().get, '/merchant-portal/dashboard', { params });
        setActiveConceptId(response.data.concept.id);
        yield put(getDashboard({
            getDashboardSuccess: true,
            activeConcept: response.data.concept,
            concepts: response.data.merchant_group.concepts.reduce((obj, item) => ({
                ...obj,
                [item.id]: item
            }), {}),
            merchantGroup: response.data.merchant_group
        }, { sent: true }));
    } catch (error) {
        yield put(getDashboard(error, {}, true));
    }
}
export function* watchGetDashboard() {
    yield takeLatest(GET_DASHBOARD, handleGetDashboard);
}


function* handleGetMerchantDetails({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().get, `/site/merchant/${getActiveConceptId()}`);
        yield put(getMerchantDetails({
            getMerchantDetailsSuccess: true,
            merchantDetails: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getMerchantDetails(error, {}, true));
    }
}
export function* watchGetMerchantDetails() {
    yield takeLatest(GET_MERCHANT_DETAILS, handleGetMerchantDetails);
}


function* handleGetMerchantLocations({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const params = {
        page: payload.page,
        perPage: payload.perPage
    };

    try {
        const response = yield call(Api().get, `/merchant-portal/concept/${getActiveConceptId()}/locations`, {
            params
        });
        yield put(getMerchantLocations({
            getMerchantLocationsSuccess: true,
            merchantLocations: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getMerchantLocations(error, {}, true));
    }
}
export function* watchGetMerchantLocations() {
    yield takeLatest(GET_MERCHANT_LOCATIONS, handleGetMerchantLocations);
}


function* handleGetMerchantReport({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    const params = {
        page: payload.page,
        perPage: payload.perPage,
        sales_summary_date_start: payload.reportDateRange,
        sales_summary_date_end: payload.salesSummaryDateEnd
    };

    try {
        const response = yield call(Api().get, `/merchant-portal/report/${getActiveConceptId()}`, { params });
        yield put(getMerchantReport({
            getMerchantReportSuccess: true,
            merchantReport: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getMerchantReport(error, {}, true));
    }
}
export function* watchGetMerchantReport() {
    yield takeLatest(GET_MERCHANT_REPORT, handleGetMerchantReport);
}


function* handleGetAccountData({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().get, '/merchant-portal/merchant-group/account');
        yield put(getAccountData({
            getAccountDataSuccess: true,
            accountData: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getAccountData(error, {}, true));
    }
}
export function* watchGetAccountData() {
    yield takeLatest(GET_ACCOUNT_DATA, handleGetAccountData);
}


function* handleGetAccountUsers({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().get, '/merchant-portal/merchant-group/list-accounts');
        yield put(getAccountUsers({
            getAccountUsersSuccess: true,
            accountUsers: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getAccountUsers(error, {}, true));
    }
}
export function* watchGetAccountUsers() {
    yield takeLatest(GET_ACCOUNT_USERS, handleGetAccountUsers);
}


function* handleGetUserAccount({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().get, `/merchant-portal/merchant-group/${payload.merchantGroupAccountId}/account`);
        yield put(getUserAccount({
            getUserAccountSuccess: true,
            userAccount: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(getUserAccount(error, {}, true));
    }
}
export function* watchGetUserAccount() {
    yield takeLatest(GET_USER_ACCOUNT, handleGetUserAccount);
}


function* handleUpdateUserAccount({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().put, `/merchant-portal/merchant-group/${payload.merchantGroupAccountId}/update-account`, payload.user);
        yield put(updateUserAccount({
            updateUserAccountSuccess: true,
            userAccount: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(updateUserAccount(error, {}, true));
    }
}
export function* watchUpdateUserAccount() {
    yield takeLatest(UPDATE_USER_ACCOUNT, handleUpdateUserAccount);
}


function* handleUpdateAccountData({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(Api().put, '/merchant-portal/merchant-group/update-account', payload);
        yield put(updateAccountData({
            updateAccountDataSuccess: true,
            userAccount: response.data
        }, { sent: true }));
    } catch (error) {
        yield put(updateAccountData(error, {}, true));
    }
}
export function* watchUpdateAccountData() {
    yield takeLatest(UPDATE_ACCOUNT_DATA, handleUpdateAccountData);
}


function* handleAddUserAccount({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(Api().post, '/merchant-portal/merchant-group/create-merchant-group-account', payload);
        yield put(addUserAccount({
            addUserAccountSuccess: true
        }, { sent: true }));
    } catch (error) {
        console.log(error);
        yield put(addUserAccount(error, {}, true));
    }
}
export function* watchAddUserAccount() {
    yield takeLatest(ADD_USER_ACCOUNT, handleAddUserAccount);
}


function* handleGetTotalLocationsCount({ payload, meta, error }) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let totalLocationsCount = 0;
    const apiError = [];
    let isError = false;

    for (const i in payload.concepts) {
        if (payload.concepts.hasOwnProperty(i)) {
            try {
                const response = yield call(Api().get, `/merchant-portal/concept/${payload.concepts[i].id}/locations`);
                totalLocationsCount += response.data.totalItems;
            } catch (error) {
                apiError.push(error);
                isError = true;
            }
        }
    }

    if (isError) {
        yield put(getTotalLocationsCount(apiError, {}, true));
        return;
    }

    yield put(getTotalLocationsCount({
        getTotalLocationsCountSuccess: true,
        totalLocationsCount
    }, { sent: true }));
}
export function* watchGetTotalLocationsCount() {
    yield takeLatest(GET_TOTAL_LOCATIONS_COUNT, handleGetTotalLocationsCount);
}